import { DateTime } from "luxon";

type AvailableSlots = {
  [date: string]: string[];
};

/**
 * Converts available slots from UTC to target timezone.
 * Handles day shifts due to timezone conversion.
 */
export function convertAvailableSlotsToTimezone(
  availableSlots: AvailableSlots,
  timezone: string
): AvailableSlots {
  const convertedSlots: AvailableSlots = {};

  for (const [utcDate, timeStrings] of Object.entries(availableSlots)) {
    for (const timeStr of timeStrings) {
      const [hour, minute] = timeStr.split(":").map(Number);

      // Create a DateTime in UTC
      const utcDateTime = DateTime.utc(
        Number(utcDate.slice(0, 4)),
        Number(utcDate.slice(5, 7)),
        Number(utcDate.slice(8, 10)),
        hour,
        minute
      );

      // Convert to target timezone
      const localDateTime = utcDateTime.setZone(timezone);

      const localDate = localDateTime.toISODate(); // e.g., "2025-06-17"
      const localTime = localDateTime.toFormat("HH:mm"); // e.g., "09:30"

      if (localDate) {
        if (!convertedSlots[localDate]) {
          convertedSlots[localDate] = [];
        }
        convertedSlots[localDate].push(localTime);
      }
    }
  }

  // Optional: sort times for each day
  for (const date in convertedSlots) {
    convertedSlots[date].sort();
  }

  return convertedSlots;
}
